<div class="wrapper">

	<div class="row">
		<div class="alert alert-info col-md-12" *ngIf="getInstructions().length > 0">
			<span [innerHTML]="getInstructions()"></span>
		</div>
		<ul class="nav nav-tabs mb-4 col-md-12">
			<li class="nav-item" *ngFor="let link of reportsLinks">
				<a [routerLink]="link.url"
				class="nav-link"
        style="display:inline-block;"
				[class.active]="urlIsActive(link.url)">
					{{link.label}}
				</a>
			</li>
		</ul>
		<div class="col-md-12">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>